/*
=========================================================
* Lex Go - v2.1.1 (Home / Landing)
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Lex Go components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";
import MKButton from "components/MKButton"; // varsa kullan; yoksa MUI Button ile devam

// Lex Go examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images (isteğe bağlı arka plan görselin varsa)
import bgImage from "assets/images/bg-presentation.jpg";

function Presentation() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        // action'ı kaldırdım; istersen WhatsApp/CTA koyarız
        sticky
      />

      {/* HERO */}
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container> </Container>
      </MKBox>

      {/* ANA KART (sayfa gövdesi) */}
      <Card
        sx={{
          p: { xs: 2, md: 4 },
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.9),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {/* ÖZELLİKLER */}
        <Container sx={{ mb: 6 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="description"
                title="Ücretsiz Temel Belgeler"
                description="Kira, İş, NDA, Ortaklık ve daha fazlası—güncel Türkçe şablonlar."
                action={{ type: "internal", route: "/hizmetler/ucretsiz/kira", label: "Göz at" }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <FilledInfoCard
                color="info"
                icon="gavel"
                title="Hızlı Kişiselleştirme"
                description="Soru akışıyla 5 dakikada sözleşmeni hazırla, PDF indir."
                action={{
                  type: "internal",
                  route: "/hizmetler/premium/girisimci",
                  label: "Nasıl çalışır?",
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <FilledInfoCard
                color="info"
                icon="video_call"
                title="Birebir Danışmanlık"
                description="Uygun uzman ve saat seç; online görüşmeyle netleştir."
                action={{ type: "internal", route: "/iletisim/form", label: "Randevu al" }}
              />
            </Grid>
          </Grid>
        </Container>
        {/* NASIL ÇALIŞIR */}
        <Container sx={{ mb: 6 }}>
          <MKTypography variant="h4" fontWeight="bold" mb={2}>
            Nasıl Çalışır?
          </MKTypography>
          <Grid container spacing={2}>
            {[
              ["looks_one", "İhtiyacını Seç", "Şablon veya paket"],
              ["looks_two", "Bilgilerini Gir", "Hızlı form akışı"],
              ["looks_3", "Önizle & Onayla", "Koşulları kontrol et"],
              ["looks_4", "İndir / Görüş", "PDF indir ya da randevu al"],
            ].map(([icon, title, desc]) => (
              <Grid key={title} item xs={12} sm={6} md={3}>
                <Card
                  sx={{
                    p: 2,
                    height: "100%",
                    borderRadius: 2,
                    border: "1px solid #e9edf5",
                    boxShadow: "none",
                  }}
                >
                  <MKTypography variant="h3" color="warning" mb={1}>
                    <Icon>{icon}</Icon>
                  </MKTypography>
                  <MKTypography variant="h6" fontWeight="bold">
                    {title}
                  </MKTypography>
                  <MKTypography variant="button" color="text" mt={0.5}>
                    {desc}
                  </MKTypography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
        {/* ÜCRETSİZ ŞABLONLAR VİTRİNİ */}
        <Container sx={{ mb: 6 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <MKTypography variant="h4" fontWeight="bold" mb={2}>
                Ücretsiz Şablonlar
              </MKTypography>
            </Grid>
            <Grid item>
              <MKButton variant="text" color="info" href="/hizmetler/ucretsiz/kira">
                Tümünü gör <Icon sx={{ ml: 0.5 }}>arrow_forward</Icon>
              </MKButton>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            {[
              ["Kira Sözleşmesi", "/hizmetler/ucretsiz/kira", "Konut / İşyeri"],
              ["İş Sözleşmesi", "/hizmetler/ucretsiz/is", "Belirli / Belirsiz"],
              ["Gizlilik (NDA)", "/hizmetler/ucretsiz/nda", "TR / EN"],
              ["Ortaklık Sözleşmesi", "/hizmetler/ucretsiz/ortaklik", "Limited / A.Ş."],
            ].map(([title, to, chip]) => (
              <Grid key={title} item xs={12} sm={6} md={3}>
                <Card sx={{ p: 2, height: "100%", borderRadius: 2, border: "1px solid #e9edf5" }}>
                  <MKTypography variant="subtitle2" color="info" fontWeight="bold">
                    Ücretsiz
                  </MKTypography>
                  <MKTypography variant="h6" fontWeight="bold" mt={0.5}>
                    {title}
                  </MKTypography>
                  <MKTypography variant="button" color="text" mt={0.5}>
                    {chip}
                  </MKTypography>
                  <MKButton
                    variant="text"
                    color="info"
                    href={to}
                    sx={{ mt: 1, p: 0, minWidth: "unset" }}
                  >
                    Göz at <Icon sx={{ ml: 0.5 }}>arrow_forward</Icon>
                  </MKButton>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
        {/* PREMIUM PAKETLER */}
        <Container sx={{ mb: 6 }}>
          <MKTypography variant="h4" fontWeight="bold" mb={2}>
            Premium Paketler
          </MKTypography>
          <Grid container spacing={2}>
            {[
              [
                "Girişimci Paketi",
                "/hizmetler/premium/girisimci",
                ["Sınırsız şablon", "Hızlı kişiselleştirme", "Aylık 1 danışmanlık"],
              ],
              [
                "İK Paketi",
                "/hizmetler/premium/ik",
                ["İşe alım & sözleşme setleri", "Ekip erişimi", "Öncelikli destek"],
              ],
            ].map(([name, to, feats]) => (
              <Grid key={name} item xs={12} md={6}>
                <Card sx={{ p: 2, height: "100%", borderRadius: 2, border: "1px solid #e9edf5" }}>
                  <MKTypography variant="h6" fontWeight="bold">
                    {name}
                  </MKTypography>
                  {feats.map((f) => (
                    <MKTypography key={f} variant="button" color="text" display="block" mt={0.5}>
                      <Icon
                        sx={{
                          fontSize: 18,
                          mr: 0.5,
                          verticalAlign: "middle",
                          color: "success.main",
                        }}
                      >
                        check_circle
                      </Icon>
                      {f}
                    </MKTypography>
                  ))}
                  <MKButton variant="contained" color="info" href={to} sx={{ mt: 2 }}>
                    Paketi İncele
                  </MKButton>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
        {/* REHBERLER & BLOG */}
        <Container sx={{ mb: 6 }}>
          <MKTypography variant="h4" fontWeight="bold" mb={2}>
            Rehberler & Blog
          </MKTypography>
          <Grid container spacing={2}>
            {[
              [
                "Hukuki Bilgiler",
                "/rehberler/hukuki-bilgiler",
                "Kira artış hakkı, depozito iadesi vb.",
              ],
              [
                "Yargıtay Kararları Özeti",
                "/rehberler/yargitay-ozetleri",
                "Güncel emsal kararlar sade anlatım.",
              ],
              [
                "Start-up Hukuku Notları",
                "/rehberler/startup-hukuku",
                "Yatırım, vesting, hissedar sözleşmeleri.",
              ],
            ].map(([title, to, desc]) => (
              <Grid key={title} item xs={12} md={4}>
                <Card sx={{ p: 2, height: "100%", borderRadius: 2, border: "1px solid #e9edf5" }}>
                  <MKTypography variant="h6" fontWeight="bold">
                    {title}
                  </MKTypography>
                  <MKTypography variant="button" color="text" mt={0.5} mb={1}>
                    {desc}
                  </MKTypography>
                  <MKButton variant="text" color="info" href={to} sx={{ p: 0, minWidth: "unset" }}>
                    Oku <Icon sx={{ ml: 0.5 }}>arrow_forward</Icon>
                  </MKButton>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
        {/* CTA / E-BÜLTEN
        <Container sx={{ mb: 2 }}>
          <Card
            sx={{
              p: 3,
              borderRadius: 2,
              bgcolor: "info.main",
              color: "white",
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={7}>
                <MKTypography variant="h5" fontWeight="bold">
                  1 Eylül açılışına özel – erken kayıt fırsatını yakala
                </MKTypography>
                <MKTypography variant="button" sx={{ opacity: 0.9 }}>
                  Güncellemeler, yeni şablonlar ve indirimler için kaydol.
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={5}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm>
                    <TextField
                      fullWidth
                      placeholder="E-posta adresi"
                      size="small"
                      sx={{
                        bgcolor: "white",
                        borderRadius: 1,
                        "& fieldset": { border: "none" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    <Button
                      variant="contained"
                      color="warning"
                      size="medium"
                      sx={{ height: "40px" }}
                    >
                      Kaydol
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider sx={{ my: 2, borderColor: "rgba(255,255,255,0.3)" }} />
            <MKTypography variant="caption" color="white">
              KVKK uyumlu veri işleme • Bu site bilgilendirme amaçlıdır (hukuki danışma için
              iletişime geçiniz)
            </MKTypography>
          </Card>
        </Container> */}
        {/* Sosyal (istersen kaldır) */}
        <MKBox pt={8} pb={2}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h5" fontWeight="bold" mb={0.5}>
                  LexGo’yu takip et
                </MKTypography>
                <MKTypography variant="body2" color="text">
                  Güncellemeler ve ipuçları için sosyal medya hesaplarımızı takip edin.
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={6}
                my={{ xs: 3, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                {/* Instagram */}
                <MKSocialButton
                  component="a"
                  href="https://www.instagram.com/lexgo.hukuk/"
                  target="_blank"
                  color="instagram"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-instagram" />
                  &nbsp;Instagram
                </MKSocialButton>

                {/* TikTok */}
                <MKSocialButton
                  component="a"
                  href="https://www.tiktok.com/@lexgo04/photo/7545211263148690696?_t=ZS-8zpun7l3BB4&_r=1"
                  target="_blank"
                  color="dark"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-tiktok" />
                  &nbsp;TikTok
                </MKSocialButton>

                {/* LinkedIn */}
                <MKSocialButton
                  component="a"
                  href="https://www.linkedin.com/in/lexgo-hukuk-829900381/"
                  target="_blank"
                  color="linkedin"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-linkedin" />
                  &nbsp;LinkedIn
                </MKSocialButton>

                {/* Twitter (X) */}
                <MKSocialButton
                  component="a"
                  href="https://x.com/LexgoHukuk"
                  target="_blank"
                  color="twitter"
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Twitter
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>

      {/* FOOTER */}
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
